import axios from 'axios';
import cookies from 'js-cookie';

function axiosConfig() {
  const callId = cookies.get('_x_call_id');
  if (callId) {
    axios.defaults.headers.common['X-Call-Id'] = callId;
  }
  return axios;
}

export default axiosConfig();
